import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Router } from "@angular/router";
import { CommonService } from "src/app/@shared/services/common.service";
import { environment } from "src/environments/environment";

@Injectable()
export class AuthGuard implements CanActivate {
  env = environment;
  constructor(public router: Router, public _common: CommonService) { }

  canActivate() {
    if (localStorage.getItem(`${this.env.panel}id_token`) && localStorage.getItem(`${this.env.panel}user`)) {
      return true;
    }
    this._common.removeLocalStorage();
    if (this.env.host.guestEnable) {
      this.router.navigate([`${this.env.isMobile ? '/m/home' : '/home'}`]);
    } else {
      this.router.navigate([`${this.env.isMobile ? '/m/login' : '/login'}`]);
    }
    return false;
  }
}

@Injectable()
export class RedirectGuard implements CanActivate {

  env = environment;
  constructor(public router: Router, public _common: CommonService) {}

  canActivate() {
    if (this.env.host.guestEnable) {
      this.router.navigate([`${this.env.isMobile ? '/m/home' : '/home'}`]);
    } else {
      this.router.navigate([`${this.env.isMobile ? '/m/login' : '/login'}`]);
    }
    return true;
  }
}
